import authAxios from '@services/authAxios';

const fetchUploadTutorial = async () => {
    try {
        const { data } = await authAxios({
            method: 'GET',
            url: '/api/v2/sellout/product-mapping/tutorial-upload',
        });
        return data?.data.url_file;
    } catch (error) {
        console.error('Error fetching upload tutorial:', error);
        return null;
    }
};

export default fetchUploadTutorial;
